import React, { Fragment } from 'react';
import './QueueWaitingComponent.css';

const QueueWaiting = props => {

    return(
        <Fragment>
            { props.queueData ? 
                <div className="queue">
                    {/* Image */}
                    <div className="loaderImg">
                        <span className="icon-gears"><span className="icon-path1"></span><span className="icon-path2"></span><span className="icon-path3"></span><span className="icon-path4"></span><span className="icon-path5"></span><span className="icon-path6"></span><span className="icon-path7"></span><span className="icon-path8"></span></span>
                    </div>
                    {/* Text */}
                    <strong> {props.queueData.Text} </strong>
                </div> : ''
            }
        </Fragment>
    )
}

export default QueueWaiting;